import * as yup from "yup";

const model = {
  supplierName: "Tripjack",
  affiliateName: "",
  service: 1,
  tripType: "1",
  bookingId: "",
  userMarkup: 0,
  adminMarkup: 0,
  adults: 1,
  child: 0,
  infant: 0,
  airlinesMarkup: 0,
  airlinesMarkupCom: "Negative",
  airlinesMarkupReturn: 0,
  airlinesMarkupComReturn: "Negative",
  flightType: "Domestic",
  bookingReferenceNumber: "",
  gstAmount: 0,
  tdsAmount: 0,
  retGstAmount: 0,
  retTdsAmount: 0,
  flightLegs: {
    onward: [
      {
        airline: "",
        supplier: "",
        pnr: "",
        airportDepartureId: 0,
        airportDestinationId: 0,
        arrivalDate: "",
        departureDate: "",
        arrivalTime: "",
        departureTime: "",
        fN: "",
        // ticketNo: "",
        gdsPnr: "",
      },
    ],
    return: [
      {
        airline: "",
        supplier: "",
        pnr: "",
        airportDepartureId: 0,
        airportDestinationId: 0,
        arrivalDate: "",
        departureDate: "",
        arrivalTime: "",
        departureTime: "",
        fN: "",
        // ticketNo: "",
        gdsPnr: "",
      },
    ],
  },
  onwardAdultBF: "0",
  onwardAdultNF: "0",
  onwardAdultTF: "0",
  onwardAdultTAF: "0",
  onwardAdultPercentage: "0",
  onwardAdultTds: "0",
  onwardAdultDiscount: "0",

  onwardChildBF: "0",
  onwardChildNF: "0",
  onwardChildTF: "0",
  onwardChildTAF: "0",
  onwardChildPercentage: "0",
  onwardChildTds: "0",
  onwardChildDiscount: "0",

  onwardInfantBF: "0",
  onwardInfantNF: "0",
  onwardInfantTF: "0",
  onwardInfantTAF: "0",
  onwardInfantPercentage: "0",
  onwardInfantTds: "0",
  onwardInfantDiscount: "0",
  /////////////
  returnAdultBF: "0",
  returnAdultNF: "0",
  returnAdultTF: "0",
  returnAdultTAF: "0",
  returnAdultPercentage: "0",
  returnAdultTds: "0",
  returnAdultDiscount: "0",

  returnChildBF: "0",
  returnChildNF: "0",
  returnChildTF: "0",
  returnChildTAF: "0",
  returnChildPercentage: "0",
  returnChildTds: "0",
  returnChildDiscount: "0",

  returnInfantBF: "0",
  returnInfantNF: "0",
  returnInfantTF: "0",
  returnInfantTAF: "0",
  returnInfantPercentage: "0",
  returnInfantTds: "0",
  returnInfantDiscount: "0",

  pax: {
    onward: [
      {
        pt: "ADULT",
        ti: "Mr",
        fN: "",
        lN: "",
        food: [],
        extraBag: [],
        seat: [],
        Wheelchair: false,
        refundable: 1,
        checkingBag: "",
        cabinBag: "",
        cc: "ECONOMY",
        pNat: "",
        dob: "",
        pNum: "",
        eD: "",
        pid: "",
        ticketNo: "",
      },
    ],
    return: [
      {
        pt: "ADULT",
        ti: "Mr",
        fN: "",
        lN: "",
        ticketNo: "",
        food: [],
        extraBag: [],
        seat: [],
        refundable: 1,
        Wheelchair: false,
        checkingBag: "",
        cabinBag: "",
        cc: "ECONOMY",
        pNat: "India",
        dob: "",
        pNum: "",

        eD: "",
        pid: "",
      },
    ],
  },
  gstMandatory: false,
  gstInfo: {
    gstNumber: "",
    email: "",
    registeredName: "",
    mobile: "",
    address: "",
  },
  ssrAmount: 0,
  returnSSRAmount: 0,
};

const validationSchema = yup.object().shape({
  supplierName: yup.string().required("Please Enter Supplier Name"),
  affiliateName: yup.string().required("Please Select Affiliate Name"),
  service: yup.string().required(),
  bookingId: yup.string().required("Booking ID is a required"),
  tripType: yup.string().optional(),
  userMarkup: yup.string().optional(),
  adminMarkup: yup.string().optional(),
  bookingReferenceNumber: yup
    .string()
    .required("Booking Reference Number is a required")
    .matches(
      /^[A-Za-z0-9]+$/,
      "Booking Reference Number should not contain special characters"
    ),

  adults: yup.string().optional(),
  child: yup.string().optional(),
  infant: yup.string().optional(),
  airlinesMarkup: yup.string().optional(),
  airlinesMarkupCom: yup.string().optional(),

  gstAmount: yup.string().optional(),
  tdsAmount: yup.string().optional(),
  retGstAmount: yup.string().optional(),
  retTdsAmount: yup.string().optional(),

  airlinesMarkupReturn: yup.string().optional(),
  airlinesMarkupComReturn: yup.string().optional(),
  flightType: yup.string().optional(),
  flightLegs: yup.object().shape({
    onward: yup.array().of(
      yup.object().shape({
        supplier: yup.string().optional(),
        airline: yup.string().required("Please Enter airline"),
        ticketNo: yup.string().optional(),
        gdsPnr: yup.string().optional(),
        pnr: yup.string().optional(),
        arrivalTime: yup.string().required("Please Enter Arrival Time"),
        departureTime: yup.string().required("Please Enter Departure Time"),
        arrivalDate: yup.string().required("Please Enter Arrival Date"),
        departureDate: yup.string().required("Please Enter Departure Date"),
        airportDepartureId: yup
          .string()
          .required("Please Enter Airport Departure"),
        airportDestinationId: yup
          .string()
          .required("Please Enter Airport Destination"),
        fN: yup.number().required("Please Enter Flight Number"),
      })
    ),
    return: yup.array().when("tripType", {
      is: (value) => value == "2" || value == "3",
      then: yup.array().of(
        yup
          .object()
          .shape({
            supplier: yup.string().optional(),
            airline: yup.string().required("Please Enter airline"),
            ticketNo: yup.string().optional(),
            gdsPnr: yup.string().optional(),
            pnr: yup.string().optional(),
            arrivalTime: yup.string().required("Please Enter Arrival Time"),
            departureTime: yup.string().required("Please Enter Departure Time"),
            arrivalDate: yup.string().required("Please Enter Arrival Date"),
            departureDate: yup.string().required("Please Enter Departure Date"),
            airportDepartureId: yup
              .string()
              .required("Please Enter Airport Departure"),
            airportDestinationId: yup
              .string()
              .required("Please Enter Airport Destination"),
            fN: yup.number().required("Please Enter Flight Number"),
          })
          .required()
      ),
    }),

    // .optional(),
  }),

  // pax details

  pax: yup.object().shape({
    onward: yup.array().of(
      yup.object().shape({
        pt: yup.string().optional(),
        ti: yup.string().optional(),
        fN: yup.string().required("Please Enter First Name"),
        lN: yup.string().required("Please Enter Last Name"),

        dob: yup.string().optional(),
        pNum: yup.string().optional(),

        eD: yup.string().optional(),
        pid: yup.string().optional(),

        food: yup.string().optional(),

        // BF: yup.string().optional(),
        // NF: yup.string().optional(),
        // TF: yup.string().optional(),
        // TAF: yup.string().optional(),
        cc: yup.string().optional(),
      })
    ),

    // .optional(),
    return: yup.array().when("tripType", {
      is: (value) => value == "2" || value == "3",
      then: yup.array().of(
        yup.object().shape({
          pt: yup.string().optional(),
          ti: yup.string().optional(),
          fN: yup.string().required("Please Enter First Name"),
          lN: yup.string().required("Please Enter Last Name"),

          dob: yup.string().optional(),
          pNum: yup.string().optional(),

          eD: yup.string().optional(),
          pid: yup.string().optional(),

          food: yup.string().optional(),

          // BF: yup.string().optional(),
          // NF: yup.string().optional(),
          // TF: yup.string().optional(),
          // TAF: yup.string().optional(),
          cc: yup.string().optional(),
          // checkingBag: yup.string().required("Please Enter checking Baggage"),
          // cabinBag: yup.string().required("Please Enter cabin Baggage"),
        })
      ),
    }),

    // .optional(),
  }),

  ///onward
  onwardAdultBF: yup.number().when("adults", {
    is: (adults) => adults > 0,
    then: yup.number().required("Required"),
  }),
  onwardAdultTAF: yup.number().when("adults", {
    is: (adults) => adults > 0,
    then: yup.number().required("Required"),
  }),
  onwardAdultTF: yup.number().when("adults", {
    is: (adults) => adults > 0,
    then: yup.number().required("Required"),
  }),
  onwardAdultNF: yup.number().when("adults", {
    is: (adults) => adults > 0,
    then: yup.number().required("Required"),
  }),
  onwardAdultPercentage: yup.number().when("adults", {
    is: (adults) => adults > 0,
    then: yup.number().required("Required"),
  }),

  // onwardAdultTds: yup.number().when("adults", {
  //   is: (adults) => adults > 0,
  //   then: yup.number().optional(),
  // }),
  // onwardAdultDiscount: yup.number().when("adults", {
  //   is: (adults) => adults > 0,
  //   then: yup.number().optional(),
  // }),
  ////////////////////
  onwardChildBF: yup.number().when("child", {
    is: (child) => child > 0,
    then: yup.number().required("Required"),
  }),
  onwardChildTAF: yup.number().when("child", {
    is: (child) => child > 0,
    then: yup.number().required("Required"),
  }),
  onwardChildTF: yup.number().when("child", {
    is: (child) => child > 0,
    then: yup.number().required("Required"),
  }),
  onwardChildNF: yup.number().when("child", {
    is: (child) => child > 0,
    then: yup.number().required("Required"),
  }),
  onwardChildPercentage: yup.number().when("child", {
    is: (child) => child > 0,
    then: yup.number().required("Required"),
  }),
  // onwardChildTds: yup.number().when("child", {
  //   is: (child) => child > 0,
  //   then: yup.number().optional(),
  // }),
  // onwardChildDiscount: yup.number().when("child", {
  //   is: (child) => child > 0,
  //   then: yup.number().optional(),
  // }),

  ////
  onwardInfantBF: yup.number().when("infant", {
    is: (infant) => infant > 0,
    then: yup.number().required("Required"),
  }),
  onwardInfantTAF: yup.number().when("infant", {
    is: (infant) => infant > 0,
    then: yup.number().required("Required"),
  }),
  onwardInfantTF: yup.number().when("infant", {
    is: (infant) => infant > 0,
    then: yup.number().required("Required"),
  }),
  onwardInfantNF: yup.number().when("infant", {
    is: (infant) => infant > 0,
    then: yup.number().required("Required"),
  }),
  onwardInfantPercentage: yup.number().when("child", {
    is: (infant) => infant > 0,
    then: yup.number().required("Required"),
  }),

  ////return

  // Conditional validation for return fare fields based on tripType
  returnAdultBF: yup.number().when("tripType", {
    is: (tripType) => tripType == 2 || tripType == 3,
    then: yup.number().when("adults", {
      is: (adults) => adults > 0,
      then: yup.number().required("Required"),
    }),
  }),
  returnAdultTAF: yup.number().when("tripType", {
    is: (tripType) => tripType == 2 || tripType == 3,
    then: yup.number().when("adults", {
      is: (adults) => adults > 0,
      then: yup.number().required("Required"),
    }),
  }),
  returnAdultTF: yup.number().when("tripType", {
    is: (tripType) => tripType == 2 || tripType == 3,
    then: yup.number().when("adults", {
      is: (adults) => adults > 0,
      then: yup.number().required("Required"),
    }),
  }),
  returnAdultNF: yup.number().when("tripType", {
    is: (tripType) => tripType == 2 || tripType == 3,
    then: yup.number().when("adults", {
      is: (adults) => adults > 0,
      then: yup.number().required("Required"),
    }),
  }),
  returnChildBF: yup.number().when("tripType", {
    is: (tripType) => tripType == 2 || tripType == 3,
    then: yup.number().when("child", {
      is: (child) => child > 0,
      then: yup.number().required("Required"),
    }),
  }),
  returnChildTAF: yup.number().when("tripType", {
    is: (tripType) => tripType == 2 || tripType == 3,
    then: yup.number().when("child", {
      is: (child) => child > 0,
      then: yup.number().required("Required"),
    }),
  }),
  returnChildTF: yup.number().when("tripType", {
    is: (tripType) => tripType == 2 || tripType == 3,
    then: yup.number().when("child", {
      is: (child) => child > 0,
      then: yup.number().required("Required"),
    }),
  }),
  returnChildNF: yup.number().when("tripType", {
    is: (tripType) => tripType == 2 || tripType == 3,
    then: yup.number().when("child", {
      is: (child) => child > 0,
      then: yup.number().required("Required"),
    }),
  }),
  returnInfantBF: yup.number().when("tripType", {
    is: (tripType) => tripType == 2 || tripType == 3,
    then: yup.number().when("infant", {
      is: (infant) => infant > 0,
      then: yup.number().required("Required"),
    }),
  }),
  returnInfantTAF: yup.number().when("tripType", {
    is: (tripType) => tripType == 2 || tripType == 3,
    then: yup.number().when("infant", {
      is: (infant) => infant > 0,
      then: yup.number().required("Required"),
    }),
  }),
  returnInfantTF: yup.number().when("tripType", {
    is: (tripType) => tripType == 2 || tripType == 3,
    then: yup.number().when("infant", {
      is: (infant) => infant > 0,
      then: yup.number().required("Required"),
    }),
  }),
  returnInfantNF: yup.number().when("tripType", {
    is: (tripType) => tripType == 2 || tripType == 3,
    then: yup.number().when("infant", {
      is: (infant) => infant > 0,
      then: yup.number().required("Required"),
    }),
  }),
  gstMandatory: yup.boolean().optional(),
  gstInfo: yup.object().shape({
    gstNumber: yup.string().when("gstMandatory", {
      is: true,
      then: yup.string().required("GST Number is required"),
    }),
    email: yup
      .string()
      .email("Invalid email!")
      .when("gstMandatory", {
        is: true,
        then: yup.string().required("Email Id is required"),
      }),
    registeredName: yup.string().when("gstMandatory", {
      is: true,
      then: yup.string().required("GST Name date is required"),
    }),
    mobile: yup.string().when("gstMandatory", {
      is: true,
      then: yup.string().required("Mobile Number is required"),
    }),
    address: yup.string().when("gstMandatory", {
      is: true,
      then: yup.string().required("GST Address is required"),
    }),
  }),
  ssrAmount: yup.number().required("Required"),
  returnSSRAmount: yup.number().required("Required"),
});

export { model, validationSchema };
